import Vue from "vue";
import Component from "vue-class-component";
import useSystemSettings from "@/hooks/useSystemSettings";

@Component({
  name: "WithSystemSettings",
  setup() {
    const { systemSettings, getData } = useSystemSettings();
    return {
      systemSettings,
      systemSettingsGetData: getData,
    };
  },
})
export default class WithSystemSettings extends Vue {
  public systemSettings!: ReturnType<typeof useSystemSettings>["systemSettings"]["value"];
  public systemSettingsGetData!: ReturnType<typeof useSystemSettings>["getData"];
}
